import React, { useImperativeHandle, forwardRef, useState } from "react";
import { Box, Typography, Breadcrumbs, Link, Divider } from "@mui/material";
import { useLocation } from "react-router-dom";
import ComponenteSnackBar from "Componentes/ComponenteSnackBar";

const MigaPan = forwardRef(({ breadcrumbs, tituloSeccion = "" }, ref) => {
  const [snackTipo, setSnackTipo] = useState("");
  const [snackMostrar, setSnackMostrar] = useState(false);
  const [snackMensaje, setSnackMensaje] = useState("");

  const location = useLocation();

  // Si no se pasan migas, construirlas desde la URL (sin IDs)
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const breadcrumbsGenerados = pathSegments
    .filter(seg => isNaN(seg)) // Elimina números (IDs)
    .map((segment, index, array) => {
      const href = "/" + pathSegments.slice(0, index + 1).join("/");
      // const label = decodeURIComponent(segment.charAt(0).toUpperCase() + segment.slice(1));


      const label = decodeURIComponent(
        segment
          .replace(/([A-Z])/g, ' $1')      // añade espacio antes de mayúscula
          .replace(/^./, (s) => s.toUpperCase()) // primera letra en mayúscula
          .trim()
      );



      return { label, href };
    });

  // Siempre incluye Dashboard al principio
  const breadcrumbsFinales = [
    { label: "Dashboard", href: "/" },
    ...(breadcrumbs ?? breadcrumbsGenerados)
  ];

  useImperativeHandle(ref, () => ({
    mostrarSnack: ({ mensaje, tipo = "info" }) => {
      setSnackMensaje(mensaje);
      setSnackTipo(tipo);
      setSnackMostrar(true);
    }
  }));

  return (
    <Box sx={{ mb: 0 }}>
      {/* Migas de pan */}
      {breadcrumbsFinales.length > 0 && (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ flexGrow: 1, mr: 2 }}>
            <Breadcrumbs separator="›" aria-label="breadcrumb">
              {breadcrumbsFinales.map((breadcrumb, index) => {
                const isLast = index === breadcrumbsFinales.length - 1;
                return isLast ? (
                  <Typography
                    key={index}
                    sx={{
                      color: "primary.main",
                      fontWeight: "bold",
                      fontSize: "inherit",
                    }}
                  >
                    {breadcrumb.label}
                  </Typography>
                ) : (
                  <Link
                    key={index}
                    underline="hover"
                    href={breadcrumb.href}
                    sx={{
                      color: "primary.main",
                      fontWeight: "bold",
                      fontSize: "inherit",
                    }}
                  >
                    {breadcrumb.label}
                  </Link>
                );
              })}
            </Breadcrumbs>
          </Box>
        </Box>
      )}

      {/* Línea y título */}
      {typeof tituloSeccion === "string" && tituloSeccion.trim() && (
        <Box sx={{ width: "80%", mt: 0 }}>
          <Divider sx={{ mb: 0, height: "2px", backgroundColor: "primary.main" }} />
          <Typography variant="h6" gutterBottom sx={{ textAlign: "right" }}>
            {tituloSeccion}
          </Typography>
        </Box>
      )}

      <ComponenteSnackBar
        open={snackMostrar}
        snackMensaje={snackMensaje}
        snackTipo={snackTipo}
        onClose={() => setSnackMostrar(false)}
      />
    </Box>
  );
});

export default MigaPan;